var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _polygon, _polygon2, _polygon3, _circle11, _path4, _circle12, _path5, _circle13, _circle14, _path6, _ellipse, _circle15, _rect, _rect2, _ellipse2, _ellipse3, _path7, _ellipse4, _circle16, _circle17, _path8, _path9, _ellipse5, _circle18, _rect3, _rect4, _ellipse6, _ellipse7, _circle19, _circle20, _path10, _ellipse8, _path11, _circle21, _rect5, _rect6, _ellipse9, _ellipse10, _path12, _path13, _path14, _path15, _ellipse11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 529.16032,
    height: 479.14405,
    viewBox: "0 0 529.16032 479.14405",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M765.72354,403.19867c-28.1703-21.05969-72.292-40.97652-121.05146-54.643-44.39571-12.44368-87.69779-18.45153-121.939-16.91729l-.17824-3.982c34.64906-1.55175,78.40036,4.50652,123.19313,17.06132,49.21419,13.794,93.81384,33.94594,122.36243,55.28863Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M762.79915,419.42a132.645,132.645,0,0,1-11.47943,54.15643q-.95064,2.14046-1.981,4.241A133.14833,133.14833,0,0,1,496.541,419.42q0-4.62167.31485-9.17157.14943-2.31379.38666-4.59967A133.13571,133.13571,0,0,1,762.79909,419.42Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M751.31978,473.57642q-.95064,2.14046-1.981,4.241-5.83542.63373-12.28455.92073c-3.55944.15942-7.22243.23917-10.96523.23917-32.69234,0-72.03715-6.03467-112.231-17.29881-44.79353-12.55559-85.31818-30.11744-114.11236-49.453q-1.47081-.98649-2.88975-1.977.14943-2.31378.38666-4.59966,2.28992,1.63222,4.72327,3.2684c28.45533,19.10443,68.57346,36.479,112.9684,48.923,39.843,11.16847,78.81718,17.15132,111.13487,17.15132q5.54229,0,10.8058-.23519Q744.53983,474.40949,751.31978,473.57642Z",
    transform: "translate(-335.41984 -210.42797)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M726.08951,475.78934c-32.69134.00079-72.03851-6.03452-112.23055-17.29975-44.79312-12.55479-85.31948-30.11732-114.11389-49.45238-29.39541-19.73857-43.17947-39.18813-38.81332-54.76584,4.366-15.57772,26.25091-25.02983,61.623-26.615l.17824,3.982c-16.51832.74014-29.98006,3.19534-40.01121,7.29724-10.00674,4.09178-16.04676,9.61345-17.95214,16.41168-1.90539,6.798.38494,14.65439,6.8072,23.35119,6.438,8.7178,16.66275,17.81181,30.39018,27.02963,28.45209,19.10528,68.57151,36.48015,112.9678,48.92363,39.844,11.16752,78.81478,17.15181,111.13517,17.15258q5.53931,0,10.80357-.23549c16.5185-.74035,29.98024-3.19534,40.01162-7.29724,10.00675-4.09178,16.04676-9.61324,17.95215-16.41147,3.42112-12.20681-6.91811-28.06791-29.11379-44.66139l2.38689-3.19222c11.42169,8.53893,19.87659,16.95584,25.12983,25.01638,5.63166,8.64167,7.46025,16.68743,5.43507,23.913-4.3662,15.57772-26.25127,25.02942-61.623,26.61484C733.493,475.71033,729.83213,475.78934,726.08951,475.78934Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 297.772,
    cy: 50.32748,
    r: 1.52555,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.3852,
    cy: 115.42627,
    r: 2.62444,
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.79158,
    cy: 218.14518,
    r: 5.18452,
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.99939,
    cy: 59.48065,
    r: 3.45535,
    fill: "#ccc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 523.55018,
    cy: 202.8899,
    r: 5.61015,
    fill: "#ccc"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.6815,
    cy: 113.28657,
    r: 2.40701,
    fill: "#ccc"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.42543,
    cy: 82.36358,
    r: 3.75502,
    fill: "#ccc"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.25695,
    cy: 191.51423,
    r: 2.40701,
    fill: "#ccc"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.99584,
    cy: 200.37057,
    r: 2.99584,
    fill: "#ccc"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.50845,
    cy: 151.06835,
    r: 3.24432,
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "256.822 6.402 250.42 6.402 250.42 0 246.985 0 246.985 6.402 240.58 6.402 240.58 9.84 246.985 9.84 246.985 16.242 250.42 16.242 250.42 9.84 256.822 9.84 256.822 6.402",
    fill: "#ccc"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.335 352.829 401.314 352.829 401.314 348.81 399.158 348.81 399.158 352.829 395.138 352.829 395.138 354.986 399.158 354.986 399.158 359.006 401.314 359.006 401.314 354.986 405.335 354.986 405.335 352.829",
    fill: "#ccc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "498.123 332.252 495.118 332.252 495.118 329.247 493.504 329.247 493.504 332.252 490.499 332.252 490.499 333.866 493.504 333.866 493.504 336.871 495.118 336.871 495.118 333.866 498.123 333.866 498.123 332.252",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 210.30838,
    cy: 186.6176,
    r: 11.1872,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.87617,
    cy: 298.99821,
    r: 11.18721,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.2465,
    cy: 203.90693,
    r: 11.18722,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.90196,
    cy: 265.43656,
    r: 11.18719,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.25061,
    cy: 143.9028,
    r: 11.18722,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.37178,
    cy: 219.67073,
    r: 11.18722,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.25061,
    cy: 97.11993,
    r: 14.74678,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M691.67038,286.19055a20.84885,20.84885,0,0,0-20.84883,20.84885c0,11.51451,20.84883,49.32542,20.84883,49.32542s20.84883-37.81091,20.84883-49.32542A20.84885,20.84885,0,0,0,691.67038,286.19055Zm0,31.01907a9.66171,9.66171,0,1,1,9.66173-9.6617,9.66167,9.66167,0,0,1-9.66173,9.6617h0Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#800ba3"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.25061,
    cy: 137.11993,
    r: 14.74678,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M545.67038,326.19055a20.84885,20.84885,0,0,0-20.84883,20.84885c0,11.51451,20.84883,49.32542,20.84883,49.32542s20.84883-37.81091,20.84883-49.32542A20.84885,20.84885,0,0,0,545.67038,326.19055Zm0,31.01907a9.66171,9.66171,0,1,1,9.66173-9.6617,9.66167,9.66167,0,0,1-9.66173,9.6617h0Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#3f3d56"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.25061,
    cy: 171.11993,
    r: 14.74678,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M730.67038,360.19055a20.84885,20.84885,0,0,0-20.84883,20.84885c0,11.51451,20.84883,49.32542,20.84883,49.32542s20.84883-37.81091,20.84883-49.32542A20.84885,20.84885,0,0,0,730.67038,360.19055Zm0,31.01907a9.66171,9.66171,0,1,1,9.66173-9.6617,9.66167,9.66167,0,0,1-9.66173,9.6617h0Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#ccc",
    style: {
      isolation: "isolate"
    }
  }), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.25061,
    cy: 245.11993,
    r: 14.74678,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M480.67038,434.19055a20.84885,20.84885,0,0,0-20.84883,20.84885c0,11.51451,20.84883,49.32542,20.84883,49.32542s20.84883-37.81091,20.84883-49.32542A20.84885,20.84885,0,0,0,480.67038,434.19055Zm0,31.01907a9.66171,9.66171,0,1,1,9.66173-9.6617,9.66167,9.66167,0,0,1-9.66173,9.6617h0Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#800ba3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 806.28614,
    cy: 557.44742,
    rx: 6.76007,
    ry: 21.53369,
    transform: "translate(-505.20259 437.21082) rotate(-39.93837)",
    fill: "#2f2e41"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.05916,
    cy: 339.54155,
    r: 43.06732,
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 430.20422,
    y: 373.34107,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 404.03674,
    y: 373.34107,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 432.38483,
    cy: 397.05537,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.21735,
    cy: 396.51023,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M746.95616,495.83258c3.84558-15.487,20.82055-24.60076,37.91473-20.35617s27.83429,20.2403,23.98871,35.7273-16.604,15.537-33.69812,11.29236S743.11057,511.31961,746.95616,495.83258Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#800ba3"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 711.97081,
    cy: 529.9859,
    rx: 6.76007,
    ry: 21.53369,
    transform: "translate(-407.4064 735.72895) rotate(-64.62574)",
    fill: "#2f2e41"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.62054,
    cy: 330.45396,
    r: 14.35864,
    fill: "#fff"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.71918,
    cy: 325.30717,
    r: 4.78621,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M763.04777,570.79734a9.57244,9.57244,0,1,1-18.83533,3.42883h0l-.00335-.01849c-.94178-5.20215,3.08038-7.043,8.28253-7.98474S762.10606,565.59525,763.04777,570.79734Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M671.78358,458.47658a29.898,29.898,0,1,0,1.6951,44.1547l36.67359,30.945a2.75511,2.75511,0,0,0,3.55755-4.20789l-.00405-.00342-36.6736-30.945A29.89973,29.89973,0,0,0,671.78358,458.47658Zm-2.3642,36.96358a22.39982,22.39982,0,1,1-2.67418-31.565l0,0A22.39982,22.39982,0,0,1,669.41938,495.44016Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.85433,498.11434a22.401,22.401,0,0,1-3.80106-30.11267q-.64243.647-1.24211,1.35516a22.39981,22.39981,0,1,0,34.23921,28.89088q.59832-.70909,1.12688-1.45239A22.401,22.401,0,0,1,637.85433,498.11434Z",
    transform: "translate(-335.41984 -210.42797)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.08894,
    cy: 517.44733,
    rx: 21.53369,
    ry: 6.76007,
    transform: "translate(-512.00949 567.92143) rotate(-69.08217)",
    fill: "#2f2e41"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.8619,
    cy: 339.54148,
    r: 43.06735,
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.2363,
    y: 373.34109,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108.40377,
    y: 373.34109,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.13944,
    cy: 397.05537,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.30692,
    cy: 396.51022,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.95225,
    cy: 328.63826,
    r: 14.71921,
    fill: "#fff"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.95224,
    cy: 328.63827,
    r: 4.90643,
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M395.505,509.91794c-3.47747-15.57379,7.63868-31.31042,24.82862-35.1488s33.94421,5.67511,37.42169,21.24884-7.91492,21.31763-25.10486,25.156S398.98249,525.49179,395.505,509.91794Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#800ba3"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.77359,
    cy: 529.98595,
    rx: 6.76007,
    ry: 21.53369,
    transform: "translate(-592.1042 443.71128) rotate(-64.62574)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M416.12724,565.50632c0,4.21515,10.85327,12.53858,22.89657,12.53858s23.33515-11.867,23.33515-16.0821-11.29193.81775-23.33515.81775S416.12724,561.29117,416.12724,565.50632Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#fff"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.58115,
    cy: 417.54139,
    r: 43.06733,
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 221.95553,
    y: 451.34107,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 248.12302,
    y: 451.34107,
    width: 13.08373,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.85861,
    cy: 475.05537,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.02615,
    cy: 474.5102,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M535.22424,587.91806c-3.47748-15.57379,7.63865-31.31042,24.82866-35.1488s33.94421,5.67511,37.42169,21.2489-7.91492,21.31769-25.10486,25.156S538.70173,603.49186,535.22424,587.91806Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M577.1739,620.50684s3.12411-13.7461-2.8117-13.12127-14.05851.93723-16.24539.93723-14.68333-1.56207-16.5578,6.56062-4.37375,18.11986.93724,24.36809c0,0,1.87447,27.49221,9.05992,29.36666s26.24255,4.06135,33.1156-4.99859a23.3002,23.3002,0,0,0,4.06135-19.05709H585.609Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#800ba3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M545.62034,641.43839s5.311,2.49929,16.24538.93724v4.68617l-16.24538-1.24965Z",
    transform: "translate(-335.41984 -210.42797)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M585.31128,657.10278l-3.53662-1.86914L597.50439,625.468a7.431,7.431,0,0,0-6.37036-10.90039l-16.50732-.44433.10742-3.999,16.50757.44434a11.43167,11.43167,0,0,1,9.79931,16.76855Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#800ba3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M547.2937,657.10278,531.564,627.33715A11.43168,11.43168,0,0,1,541.363,610.5686l16.50781-.44434.10742,3.999-16.50757.44433a7.431,7.431,0,0,0-6.37012,10.90039l15.72974,29.76563Z",
    transform: "translate(-335.41984 -210.42797)",
    fill: "#800ba3"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.10465,
    cy: 627.84819,
    rx: 7.50055,
    ry: 23.89244,
    transform: "translate(-565.0462 664.02437) rotate(-62.12179)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg7);
export default __webpack_public_path__ + "static/media/svg7.74d046b8fcd5464408a85708b333c69a.svg";
export { ForwardRef as ReactComponent };